import {
  Avatar,
  FlexRow,
  Panel,
  Text,
  IconContainer,
  FlexSpacer,
} from '@epam/loveship'
import { ExtendedPoint } from '../../../../../../constants/types'
import { getPointCardIcon } from '../../../../../../utils/points/getPointCardIcon'
import { useGetPointReviewQuery } from '../../../../../../store'
import { PointCardReview } from './PointCardReview'
import css from './PointCard.module.scss'
import { useSideBarControlls } from '../../../../../../hooks/useSideBarControlls'

interface PointCardProps {
  point: ExtendedPoint
}

export const PointCard: React.FC<PointCardProps> = ({ point }) => {
  const { id, name, iconId, creator, layerName } = point
  const icon = getPointCardIcon[`${iconId}`] ?? getPointCardIcon['20']
  const { data: reviews = [] } = useGetPointReviewQuery(id)
  const { showPointInfo } = useSideBarControlls()

  //   const categoryClassNames: Record<string, string> = {
  //     'Other': 'categoryOther',
  //     'Entertainment': 'categoryEntertainment',
  //     'Education': 'categoryEducation',
  //     'Sport': 'categorySport',
  //     'Relaxation': 'categoryRelax',
  //     'Culture and arts': 'categoryCulture',
  //   }

  //   const currentCategoryClassName = categoryClassNames[categoryName]

  //   const categoryClassName = css.eventCategoryText
  //   const additionalClassName = css[currentCategoryClassName]
  //   const combinedClassName = [categoryClassName, additionalClassName].join(' ')

  //   const { showEventInfo } = useSideBarControlls()
  //   const nameHiddenRef = useRef<HTMLDivElement>(null)
  //   const [tooltipContent, setTooltipContent] = useState('')

  //   useEffect(() => {
  //     const nameHiddenWidth = nameHiddenRef?.current?.offsetWidth ?? 0
  //     if (nameHiddenWidth > MAX_CHAR_LIMIT.FIELD_LENGTH_TOOLTIP_NAME) {
  //       setTooltipContent(name)
  //     }
  //   }, [name])

  return (
    <div>
      <FlexRow
        vPadding="12"
        spacing="12"
        padding="24"
        onClick={() => showPointInfo(point)}
      >
        <Panel style={{ width: '100%' }} background="white" shadow>
          <FlexRow padding="12">
            <IconContainer cx={css.micCalendar} icon={icon} />
            <Text cx={css.dateText} font="sans" rawProps={{ title: layerName }}>
              {layerName}
            </Text>
            {/* <IconContainer cx={css.micLocation} icon={Location} />
            <Text cx={css.dateText} font="sans" rawProps={{ title: 'School' }}>
              School
            </Text> */}
          </FlexRow>

          {/* <FlexRow cx={css.eventCategory} padding='12' vPadding='12' >
            <FlexCell width='100%'>
              <Text cx={combinedClassName} font='sans'>{categoryName}</Text>
            </FlexCell>
          </FlexRow> */}

          <FlexRow padding="12">
            {/* <Tooltip
              content={tooltipContent}
              placement='left-start'
              color='white'
            > */}
            <Text
              cx={css.pointInfoText}
              lineHeight="24"
              fontSize="18"
              font="sans-semibold"
            >
              {name}
            </Text>
            {/* </Tooltip> */}
          </FlexRow>

          {/* <FlexRow cx={css.hiddenText} padding='12'>
            <Text
              ref={nameHiddenRef}
              lineHeight='24'
              fontSize='18'
              font='sans-semibold'
            >{name}</Text>
          </FlexRow> */}

          <FlexRow key={id} padding="12">
            <Avatar alt={creator?.name} img={creator?.picture} size="24" />
            <Text>{creator?.name}</Text>
            <FlexSpacer />
            <PointCardReview reviews={reviews} />
          </FlexRow>
        </Panel>
      </FlexRow>
    </div>
  )
}
